module.exports = __webpack_public_path__ + "img/help-circle.932aacfb.svg";